import React from "react";
import ConfirmEmailForm from "../../components/Auth/ConfirmEmailForm";
import AuthBackgroundSlideshow from "../../components/AuthBackground/Slideshow";

const ConfirmEmail = () => {
  return (
    <>
      {/* Animated Background Slideshow */}
      <AuthBackgroundSlideshow />
      <ConfirmEmailForm />
    </>
  );
};

export default ConfirmEmail;
